import { Component, inject, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {ThemePalette} from "@angular/material/core";
import { MatProgressSpinner, ProgressSpinnerMode } from '@angular/material/progress-spinner';
import {OverlayConfig, OverlayRef} from '@angular/cdk/overlay';
import { OverlayService } from './overlay-service';
import { AllStatus } from '../../core/services/status/all-status';
import * as _ from "lodash";

@Component({
  selector: 'app-progress-spinner',
  imports: [MatProgressSpinner],
  templateUrl: './progress-spinner.html',
  styleUrl: './progress-spinner.scss'
})
export class ProgressSpinnerComponent implements OnInit {
  @Input() color: ThemePalette;
  @Input() diameter?: number = 294;
  @Input() mode: ProgressSpinnerMode = "indeterminate";
  @Input() strokeWidth?: number = 25;
  @Input() value?: number = 50;
  @Input() backdropEnabled = true;
  @Input() positionGloballyCenter = true;
  @Input() displayProgressSpinner: boolean;

  @ViewChild('progressSpinnerRef') private progressSpinnerRef: TemplateRef<any>;
  private progressSpinnerOverlayConfig: OverlayConfig;
  private overlayRef: OverlayRef;

  vcRef =  inject(ViewContainerRef);
  overlay = inject(OverlayService);
  allStatus = inject(AllStatus);

  ngOnInit() {
    // Config for Overlay Service
    this.progressSpinnerOverlayConfig = {
      hasBackdrop: this.backdropEnabled
    };
    if (this.positionGloballyCenter) {
      this.progressSpinnerOverlayConfig['positionStrategy'] = this.overlay.positionGloballyCenter();
    }
    // Create Overlay for progress spinner
    this.overlayRef = this.overlay.createOverlay(this.progressSpinnerOverlayConfig);
  }

  ngAfterViewChecked(){
    if (this.displayProgressSpinner && !this.overlayRef.hasAttached()) {    
      this.overlay.attachTemplatePortal(this.overlayRef, this.progressSpinnerRef, this.vcRef);
    } else if (!this.displayProgressSpinner && this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
    }
  }

  sizeDiameter():number{
    //window.innerWidth < 768 ? this.diameter = 58 : this.diameter = 294;
    if(window.innerWidth === 1920){
      this.diameter = 294;
    }
    if(window.innerWidth < 1920 && window.innerWidth >= 1200){      
      this.diameter =  _.round( (window.innerWidth/1920) * 294, 2);
    }
    if(window.innerWidth < 1200 && window.innerWidth >= 768){
      this.diameter =  _.round( (1200/1920) * 294, 2);
    }
    if(window.innerWidth < 768){
      this.diameter = 58;
    }
    return this.diameter || 294;
  }

  strokeWidthSize(){
    //window.innerWidth < 768 ? this.strokeWidth = 5 : this.strokeWidth = 25;
    if(window.innerWidth === 1920){
      this.strokeWidth = 25;
    }
    if(window.innerWidth < 1920 && window.innerWidth >= 1200){      
      this.strokeWidth =  _.round( (window.innerWidth/1920) * 25, 0);
    }
    if(window.innerWidth < 1200 && window.innerWidth >= 768){
      this.strokeWidth =  16;
    }
    if(window.innerWidth < 768){
      this.strokeWidth = 5;
    }
    return this.strokeWidth || 15;
  }
}
